module.exports = __webpack_public_path__ + "static/video-mob-3b779735361229a27926e297a76f5958.mp4";